// AUTO-GENERATED by scripts/generatePublicIndex.js — DO NOT EDIT BY HAND
export type MarkdownFile = { path: string; name: string; url: string; content: string };

const contrate_aprendiz: MarkdownFile[] = [
    {
      path: '1_invista_no_futuro.md',
      name: '1_invista_no_futuro',
      url: '',
      content: `<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
    <div class="order-2 md:order-1 md:max-w-[60%] space-y-4">
        <h2 class="font-semibold text-xl text-center md:text-2xl leading-tight text-[#3A3168]">
            Invista no Futuro da Sua Empresa
        </h2>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            A contratação de um aprendiz vai muito além do cumprimento de uma obrigação legal, é uma decisão estratégica que fortalece a cultura organizacional, contribui para a responsabilidade social e prepara sua empresa para o futuro.
        </p>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            Ao optar por essa parceria, você estará formando profissionais desde o início da carreira, alinhando-os aos valores e às necessidades do seu negócio.
        </p>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            Na <strong>APAMI</strong>, oferecemos uma solução completa: cuidamos de todas as etapas do processo, desde a seleção criteriosa dos candidatos até a capacitação teórica e o acompanhamento contínuo no ambiente de trabalho. Assim, garantimos que o jovem evolua profissionalmente e gere resultados reais para a sua empresa.
        </p>
    </div>
    <div class="order-1 md:order-2 md:max-w-[40%]">
        <img src="__PUBLIC_URL__/page/contrate_aprendiz/man-review-stars.svg" alt="Ilustração" class="h-[280px] md:h-[360px] md:w-[480px] rounded-md shrink-0" />
    </div>
</div>`,
    },
    {
      path: '2_por_que_contratar.md',
      name: '2_por_que_contratar',
      url: '',
      content: `<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
    <div class="md:max-w-[50%]">
        <img src="__PUBLIC_URL__/page/contrate_aprendiz/graph-analise.svg" alt="Ilustração" class="h-[360px] md:h-[480px] md:w-[480px] rounded-md shrink-0" />
    </div>
    <div class="md:max-w-[50%] space-y-4">
        <h2 class="font-semibold text-xl text-center md:text-2xl leading-tight text-[#3A3168]">
            Por que contratar um aprendiz com a APAMI?
        </h2>
        <div class="space-y-3">
            <h3 class="font-semibold text-lg md:text-xl text-[#3A3168]">Cumprimento da Lei da Aprendizagem</h3>
            <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">Esteja em total conformidade com a legislação, atuando com segurança jurídica e tranquilidade no cumprimento das suas obrigações.</p>
        </div>
        <div class="space-y-3">
            <h3 class="font-semibold text-lg md:text-xl text-[#3A3168]">Redução de Custos Trabalhistas</h3>
            <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">Aproveite os benefícios e condições especiais previstos em lei para a contratação de aprendizes, otimizando recursos sem abrir mão da qualidade.</p>
        </div>
        <div class="space-y-3">
            <h3 class="font-semibold text-lg md:text-xl text-[#3A3168]">Formação e Retenção de Talentos</h3>
            <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">Desenvolva jovens profissionais desde o início da carreira, moldando habilidades e atitudes alinhadas à cultura e às necessidades da sua empresa.</p>
        </div>
        <div class="space-y-3">
            <h3 class="font-semibold text-lg md:text-xl text-[#3A3168]">Fortalecimento da Imagem Institucional</h3>
            <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">Mostre ao mercado e à comunidade que a sua empresa é socialmente responsável, comprometida com a inclusão e o desenvolvimento sustentável.</p>
        </div>
        <div class="pt-6 md:pt-2 h-20 flex justify-center w-full">
          <a href="https://forms.gle/WBF1uiyxeErjEYWu8" class="inline-flex items-center justify-center w-full no-underline rounded-lg bg-[#3A3168] text-white px-6 py-2 font-semibold hover:bg-[#322a5b]">Quero Contratar um Aprendiz</a>
        </div>
    </div>
</div>`,
    },
];

const home: MarkdownFile[] = [
    {
      path: '1_futuro_aprendizado.md',
      name: '1_futuro_aprendizado',
      url: '',
      content: `<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
  <div class="order-2 md:order-1 md:max-w-[50%] space-y-4">
    <h1 class="font-semibold text-2xl text-justify md:text-5xl leading-tight text-[#3A3168]">Formando o Futuro<br />Através do Aprendizado</h1>
    <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">Programas de aprendizagem que conectam jovens talentos a empresas comprometidas com o desenvolvimento do futuro.</p>
    <div class="flex flex-col md:flex-row gap-4 w-full">
      <a class="inline-flex items-center justify-center w-full md:w-auto px-6 py-3 rounded-md bg-[#3A3168] text-white no-underline hover:bg-[#322a5b] focus:outline-none focus:ring-2 focus:ring-[#3A3168] focus:ring-offset-1" href="https://forms.gle/NQTrM2wJHKpHCpXZA">Inscreva-se</a>
    </div>
  </div>
  <div class="order-1 md:order-2 md:max-w-[50%]">
    <img src="__PUBLIC_URL__/page/home/rocket.svg" alt="Ilustração" class="flex items-center justify-center h-[280px] md:h-[360px] md:w-[480px] rounded-md shrink-0" />
  </div>
</div>`,
    },
    {
      path: '2_descritivo.md',
      name: '2_descritivo',
      url: '',
      content: `<div class="flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
  <div class="order-1 md:max-w-[50%]">
    <img src="__PUBLIC_URL__/page/home/talking.svg" alt="Ilustração" class="h-[280px] md:h-[360px] md:w-[480px] rounded-md shrink-0" />
  </div>
  <div class="order-2 md:max-w-[50%] space-y-4">
    <p class="text-md md:text-lg text-justify leading-relaxed text-slate-700"> Na <strong>APAMI</strong>, acreditamos que oportunidades transformam vidas.  Desenvolvemos programas de aprendizagem que unem teoria e prática para inserir jovens no mercado de trabalho com preparo, responsabilidade e propósito. Atuamos lado a lado com empresas parceiras, garantindo que cada aprendiz tenha acompanhamento, capacitação e suporte para crescer profissionalmente.</p>
  </div>
</div>`,
    },
];

const programas: MarkdownFile[] = [
    {
      path: '1_formando_jovens.md',
      name: '1_formando_jovens',
      url: '',
      content: `<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
    <div class="md:max-w-full space-y-4">
        <h1 class="font-semibold text-xl text-center md:text-4xl leading-tight text-[#3A3168]">
            Formando Jovens para o Futuro
        </h1>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            A <strong>APAMI</strong> desenvolve iniciativas que unem <strong>formação social</strong>, <strong>capacitação profissional</strong> e <strong>oportunidades reais de trabalho</strong>, garantindo que jovens ingressem no mercado com <strong>preparo técnico</strong>, <strong>postura ética</strong> e <strong>confiança</strong>.
        </p>
    </div>
</div>`,
    },
    {
      path: '2_scfv.md',
      name: '2_scfv',
      url: '',
      content: `<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
    <div class="order-2 md:order-1 md:max-w-[60%] space-y-4">
        <h2 class="font-semibold text-lg text-center md:text-2xl leading-tight text-[#3A3168]">
            Serviço de Convivência e Fortalecimento de Vínculos
        </h2>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            O <strong>SCFV</strong> atende jovens de <strong>14 a 22 anos</strong>, promovendo <strong>formação integral</strong> para prepará-los para os desafios do mundo do trabalho. Durante o programa, os participantes vivenciam <strong>oficinas práticas</strong> e <strong>atividades socioeducativas</strong> que desenvolvem competências essenciais para a vida profissional e pessoal.
        </p>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            O <strong>SCFV</strong> promove <strong>autoconfiança</strong>, <strong>disciplina</strong> e <strong>senso de pertencimento</strong>, incentivando cada jovem a construir um <strong>projeto de vida consistente</strong> e alinhado aos seus objetivos. Ao final dessa etapa, os participantes podem ser indicados para <strong>processos seletivos em empresas parceiras</strong>, com possibilidade de ingresso como aprendizes conforme a <strong>Lei da Aprendizagem nº 10.097/2000</strong>, um passo importante para a <strong>inserção segura e promissora no mercado de trabalho</strong>.
        </p>
    </div>
    <div class="order-1 md:order-2 md:max-w-[40%]">
        <img src="__PUBLIC_URL__/page/programas/presentation.svg" alt="Ilustração" class="h-[280px] md:h-[360px] md:w-[480px] rounded-md shrink-0" />
    </div>
</div>`,
    },
    {
      path: '3_programas_aprendizagem.md',
      name: '3_programas_aprendizagem',
      url: '',
      content: `<h1 class="font-semibold text-lg text-center md:text-2xl leading-tight text-[#3A3168]">
    Programas de Aprendizagem
</h1>
<div class="md:max-w-full space-y-2">
    <div class="flex flex-col md:flex-row md:flex-wrap justify-center md:justify-between md:items-start gap-8">
      <div class="md:max-w-full space-y-2 bg-[#E9E7F5] rounded-lg p-6">
        <h3 class="font-semibold text-md text-center md:text-xl leading-tight text-[#3A3168]">
            Arco Assistente Administrativo
        </h3>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            O Arco Assistente Administrativo é um programa de aprendizagem que visa formar profissionais capacitados para atuar na área administrativa, com foco na gestão de processos, organização e eficiência.
        </p>
        <ul class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            <li><strong>Faixa etária:</strong> 14 a 24 anos.</li>
            <li><strong>CBO 4110-10:</strong> Assistente Administrativo</li>
        </ul>
      </div>
      <div class="md:max-w-full space-y-2  bg-[#E9E7F5] rounded-lg p-6">
        <h3 class="font-semibold text-md text-center md:text-xl leading-tight text-[#3A3168]">
            Arco Monitor de Transporte Escola
        </h3>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            O Arco Monitor de Transporte Escola é um programa de aprendizagem que visa formar profissionais capacitados para atuar na área administrativa, com foco na gestão de processos, organização e eficiência.
        </p>
        <ul class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            <li><strong>Faixa etária:</strong> 18 a 24 anos.</li>
            <li><strong>CBO 3341-15:</strong> Monitor de Transporte Escola</li>
        </ul>
      </div>
      <div class="md:max-w-full space-y-2  bg-[#E9E7F5] rounded-lg p-6">
        <h3 class="font-semibold text-md text-center md:text-xl leading-tight text-[#3A3168]">
            Arco Auxiliar de Produção
        </h3>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            O Arco Auxiliar de Produção é um programa de aprendizagem que visa formar profissionais capacitados para atuar na área administrativa, com foco na gestão de processos, organização e eficiência.
        </p>
        <ul class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            <li><strong>Faixa etária:</strong> 18 a 24 anos.</li>
            <li><strong>CBO 3912-05:</strong> Inspetor de Qualidade</li>
            <li><strong>CBO 4141-05:</strong> Almoxarife</li>
            <li><strong>CBO 4142-10:</strong> Apontador de Produção</li>
            <li><strong>CBO 7841-10:</strong> Embalador, a máquina</li>
            <li><strong>CBO 7842-05:</strong> Alimentador de Linha de Produção</li>
        </ul>
      </div>
            <div class="md:max-w-full space-y-2  bg-[#E9E7F5] rounded-lg p-6">
        <h3 class="font-semibold text-md text-center md:text-xl leading-tight text-[#3A3168]">
            Arco Comércio Atacado e Varejo
        </h3>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            O Arco Comércio Atacado e Varejo é um programa de aprendizagem que visa formar profissionais capacitados para atuar na área comércio atacado e varejo, com foco na gestão de processos, organização e eficiência.
        </p>
        <ul class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            <li><strong>Faixa etária:</strong> 18 a 24 anos.</li>
            <li><strong>CBO 7841-05:</strong> Embalador, a mão</li>
            <li><strong>CBO 5211-10:</strong> Vendedor de Comércio Varejista</li>
            <li><strong>CBO 5211-25:</strong> Repositor de Mercadorias</li>
            <li><strong>CBO 5211-40:</strong> Atendente de Lojas e Mercados</li>
        </ul>
      </div>
    </div>
</div>

<div class="md:max-w-full mt-4 rounded-lg p-6">
  <h3 class="font-semibold text-xl text-center md:text-2xl leading-tight text-[#3A3168]">
    Venha fazer parte!
  </h3>
  <div class="mt-6 flex flex-col md:flex-row w-full items-center justify-center gap-4 md:gap-6">
    <div class="text-center w-full md:w-auto">
      <h3 class="font-semibold text-lg text-center md:text-xl leading-tight text-[#3A3168]">Para Jovem</h3>
      <a href="https://forms.gle/NQTrM2wJHKpHCpXZA" class="inline-flex items-center justify-center w-full md:w-auto no-underline rounded-lg bg-[#3A3168] text-white px-5 py-2 font-semibold hover:bg-[#322a5b]">Inscreva-se</a>
    </div>
    <div class="text-center w-full md:w-auto">
      <h3 class="font-semibold text-lg text-center md:text-xl leading-tight text-[#3A3168]">Para Empresa</h3>
      <a href="/contrate-aprendiz" class="inline-flex items-center justify-center w-full md:w-auto no-underline rounded-lg bg-[#3A3168] text-white px-5 py-2 font-semibold hover:bg-[#322a5b]">Contrate um Aprendiz</a>
    </div>
    
  </div>
</div>
`,
    },
];

const quem_somos: MarkdownFile[] = [
    {
      path: '1_capacitando_geracoes.md',
      name: '1_capacitando_geracoes',
      url: '',
      content: `<h1 class="font-semibold text-xl md:text-2xl text-center justify-center md:text-4xl text-[#3A3168]">
    Capacitando Gerações com Propósito
</h1>
<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
    <div class="order-2 md:order-1 md:max-w-[50%] space-y-4">
        <h2 class="font-semibold text-lg md:text-xl text-center md:text-2xl leading-tight text-[#3A3168]">
            + de 50 Anos de História
        </h2>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            Fundada em <strong>17 de dezembro de 1972</strong> por membros do <strong>Rotary Club de Itatiba</strong>, a <strong>APAMI</strong> nasceu com o propósito de integrar jovens ao mercado de trabalho, oferecendo <strong>oportunidades</strong> e <strong>orientação</strong> para que construam uma base sólida e um futuro promissor.
        </p>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            Ao longo de sua trajetória, a entidade tem sido uma força transformadora por meio do <strong>Serviço de Convivência e Fortalecimento de Vínculos (S.C.F.V)</strong> e dos <strong>Programas de Aprendizagem (P.A)</strong>, impactando <strong>milhares de vidas</strong> com educação, suporte e desenvolvimento profissional.
        </p>
    </div>
    <div class="order-1 md:order-2 md:max-w-[50%]">
        <img src="__PUBLIC_URL__/page/quem_somos/idea.svg" alt="Ilustração" class="h-[280px] md:h-[380px] md:w-[480px] rounded-md shrink-0" />
    </div>
</div>`,
    },
    {
      path: '2_apami_rotary.md',
      name: '2_apami_rotary',
      url: '',
      content: `
<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
    <div class="order-1 md:order-1 md:max-w-[50%]">
        <img src="__PUBLIC_URL__/page/quem_somos/metting.svg" alt="Ilustração" class="h-[280px] md:h-[360px] md:w-[480px] rounded-md shrink-0" />
    </div>
    <div class="order-2 md:order-2 md:max-w-[50%] space-y-4">
        <h2 class="font-semibold text-lg md:text-xl text-center md:text-2xl leading-tight text-[#3A3168]">
            APAMI & Rotary Club de Itatiba
        </h2>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            Sob a liderança e o cuidado do <strong>Rotary Club de Itatiba</strong>, a <strong>APAMI</strong> dedica-se a formar <strong>futuros promissores</strong> e fortalecer os <strong>laços</strong> que unem nossa comunidade. Com foco no <strong>desenvolvimento integral dos jovens</strong>, promovemos <strong>inclusão social</strong>, <strong>capacitação profissional</strong> e o <strong>fortalecimento de vínculos</strong>, criando <strong>oportunidades reais</strong> de transformação e crescimento.
        </p>
    </div>
</div>`,
    },
    {
      path: '3_missao_visao_valores.md',
      name: '3_missao_visao_valores',
      url: '',
      content: `<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
    <div class="md:max-w-[30%] space-y-4">
        <h2 class="font-semibold text-lg text-center md:text-2xl leading-tight text-[#3A3168]">
            Missão
        </h2>
        <p class="text-md md:text-lg text-justify leading-relaxed text-slate-700">
            Capacitar jovens por meio do <strong>Serviço de Convivência e Fortalecimento de Vínculos (S.C.F.V)</strong> e dos <strong>Programas de Aprendizagem (P.A)</strong>, preparando-os para um <strong>futuro promissor</strong>. Oferecemos <strong>habilidades práticas</strong>, <strong>conhecimento</strong> e a <strong>confiança necessária</strong> para que prosperem em suas carreiras e em suas vidas.
        </p>
    </div>
    <div class="md:max-w-[30%] space-y-4">
        <h2 class="font-semibold text-lg text-center md:text-2xl leading-tight text-[#3A3168]">
            Visão
        </h2>
        <p class="text-md md:text-lg text-justify leading-relaxed text-slate-700">
            Contribuir para uma sociedade em que <strong>todos os jovens</strong> tenham <strong>igualdade de oportunidades</strong> para explorar seu potencial, <strong>desenvolver-se plenamente</strong>, alcançar seus objetivos e <strong>contribuir de forma positiva</strong> para o crescimento social e econômico.
        </p>
    </div>
    <div class="md:max-w-[30%] space-y-4">
        <h2 class="font-semibold text-lg text-center md:text-2xl leading-tight text-[#3A3168]">
            Valores
        </h2>
        <ul>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Responsabilidade Social
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Empatia
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Transparência
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Cuidado
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Inovação
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Parcerias Duradouras
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Excelência
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Inclusão
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Empoderamento
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Colaboração
            </li>
            <li class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Ética
            </li>
        </ul>
    </div>
</div>`,
    },
    {
      path: '4_desenvolvimento_social.md',
      name: '4_desenvolvimento_social',
      url: '',
      content: `<div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
    <div class="order-2 md:order-1 md:max-w-[50%] space-y-4">
        <h2 class="font-semibold text-lg text-center md:text-2xl leading-tight text-[#3A3168]">
            Desenvolvimento Social
        </h2>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            A <strong>APAMI</strong> atende jovens de <strong>14 a 24 anos</strong>, que iniciam sua jornada no <strong>Serviço de Convivência e Fortalecimento de Vínculos (S.C.F.V)</strong> e, muitas vezes, avançam para o <strong>Programa de Aprendizagem (P.A)</strong>.
        </p>
        <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
            Nossa atuação vai além do ensino: promovemos <strong>atividades sociais</strong>, <strong>aprendizado prático</strong> em parceria com empresas, desenvolvimento de <strong>habilidades profissionais</strong> e <strong>apoio emocional</strong>, garantindo um <strong>crescimento completo e sustentável</strong>.
        </p>
    </div>
    <div class="order-1 md:order-2 md:max-w-[50%]">
        <img src="__PUBLIC_URL__/page/quem_somos/working.svg" alt="Ilustração" class="h-[280px] md:h-[360px] md:w-[480px] rounded-md shrink-0" />
    </div>
</div>`,
    },
    {
      path: '5_reconhecimentos_certificados.md',
      name: '5_reconhecimentos_certificados',
      url: '',
      content: `<div class="md:max-w-full bg-[#E9E7F5] rounded-lg p-10 space-y-4">
    <h1 class="font-semibold text-xl text-center justify-center md:text-4xl text-[#3A3168]">
        Reconhecimentos e Certificados
    </h1>
    <div class="flex flex-col md:flex-row justify-center md:items-start justify-between gap-8">
        <div class="md:max-w-full space-y-4">
            <p class="text-md md:text-xl text-justify leading-relaxed text-slate-700">
                Ao longo de sua trajetória, a <strong>APAMI</strong> conquistou importantes títulos e certificações que reforçam seu compromisso com a <strong>transparência</strong>, a <strong>responsabilidade social</strong> e a <strong>excelência</strong> na execução de seus programas e serviços. Esses reconhecimentos atestam a <strong>seriedade</strong> de nossa atuação e a <strong>confiança</strong> depositada por órgãos públicos e parceiros.
            </p>
            <h2 class="font-semibold text-lg text-left justify-center md:text-2xl text-[#3A3168]">
                Principais Títulos e Certificações
            </h2>
            <ul class="text-md md:text-xl text-justify leading-relaxed text-slate-700 text-[#3A3168]">
                <li>
                    <strong>CMDCA</strong> Certificado de Registro no Conselho Municipal dos Direitos da Criança e do Adolescente
                </li>
                <li>
                    <strong>CMAS</strong> Registro no Conselho Municipal de Assistência Social de Itatiba-SP
                </li>
                <li>
                    <strong>Utilidade Pública Estadual</strong>
                </li>
                <li>
                    <strong>Utilidade Pública Municipal</strong>
                </li>
                <li>
                    <strong>Certificação CEBAS</strong> – Certificado de Entidade Beneficente de Assistência Social
                </li>
            </ul>
        </div>
    </div>
</div>`,
    },
];

export const staticPagesData: Record<string, MarkdownFile[]> = {
  'contrate_aprendiz': contrate_aprendiz,
  'home': home,
  'programas': programas,
  'quem_somos': quem_somos,
};

export function getStaticMarkdown(folder: string): MarkdownFile[] {
  return staticPagesData[folder] || [];
}
